export default __webpack_public_path__ + "static/media/spindex-banner.261b9eff.gif";